/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auto_Uppercase_HelpInputs */

const en_auto_uppercase_help = /** @type {(inputs: Auto_Uppercase_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto capitalize words at the beginning of sentences`)
};

const fr_auto_uppercase_help = /** @type {(inputs: Auto_Uppercase_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mettre automatiquement en majuscule les mots en début de phrase`)
};

const de_auto_uppercase_help = /** @type {(inputs: Auto_Uppercase_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wörter am Satzanfang automatisch großschreiben`)
};

const it_auto_uppercase_help = /** @type {(inputs: Auto_Uppercase_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mettere automaticamente in maiuscolo le parole all'inizio delle frasi`)
};

const ru_auto_uppercase_help = /** @type {(inputs: Auto_Uppercase_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Автоматическое добавление заглавных букв в начало предложений`)
};

const es_auto_uppercase_help = /** @type {(inputs: Auto_Uppercase_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Capitalizar automáticamente las palabras al principio de las oraciones`)
};

const zh_cn2_auto_uppercase_help = /** @type {(inputs: Auto_Uppercase_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自动将句首单词大写`)
};

const ja_auto_uppercase_help = /** @type {(inputs: Auto_Uppercase_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文頭の単語を自動で大文字にする`)
};

const hi_auto_uppercase_help = /** @type {(inputs: Auto_Uppercase_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वाक्यों के आरंभ में आने वाले शब्दों को स्वतः बड़े अक्षरों में बदलें`)
};

const pt_pt2_auto_uppercase_help = /** @type {(inputs: Auto_Uppercase_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Capitalizar automaticamente as palavras no início das frases.`)
};

/**
* | output |
* | --- |
* | "Auto capitalize words at the beginning of sentences" |
*
* @param {Auto_Uppercase_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const auto_uppercase_help = /** @type {((inputs?: Auto_Uppercase_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auto_Uppercase_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_auto_uppercase_help(inputs)
	if (locale === "de") return de_auto_uppercase_help(inputs)
	if (locale === "it") return it_auto_uppercase_help(inputs)
	if (locale === "ru") return ru_auto_uppercase_help(inputs)
	if (locale === "es") return es_auto_uppercase_help(inputs)
	if (locale === "zh-CN") return zh_cn2_auto_uppercase_help(inputs)
	if (locale === "ja") return ja_auto_uppercase_help(inputs)
	if (locale === "hi") return hi_auto_uppercase_help(inputs)
	if (locale === "pt-PT") return pt_pt2_auto_uppercase_help(inputs)
	return en_auto_uppercase_help(inputs)
});